import type { ExtensionConfig } from '@goto/shell'
import { PrerequisiteRuleTypes } from '@goto/shell'

const extensionConfig: ExtensionConfig = {
  id: '@dce/engagements-onboarding-ui-extension',
  url: new URL('/experiences/engagements-onboarding/@dce/engagements-onboarding-ui-extension.mjs', location.origin),
  esModule: true,
  prerequisites: {
    [PrerequisiteRuleTypes.CONTACT_CENTER_FLAGS]: 'engagements && !plg-motions.engagements',
  },
}

export default extensionConfig
